import { VersionableId } from '../../../../types/versionableId';
import { useAppSelector } from '../../../../store/hooks';
import { selectEsmeByVersionableId } from '../../../../store/esme/esmeSelector';
import { selectAllSmscByCommitId } from '../../../../store/smsc/smscSelector';
import EsmeForm from '../../components/esme/EsmeForm';

type Props = {
  readonly esmeId: VersionableId;
  readonly hideEsmeForm: () => void;
};

const EsmeViewFormContainer = (props: Props) => {
  const { esmeId, hideEsmeForm } = props;

  const esme = useAppSelector(state => selectEsmeByVersionableId(state, esmeId));
  const smscIdList = useAppSelector(state => selectAllSmscByCommitId(state, esmeId.commitId))
    .map(smsc => smsc.object)
    .map(smscObject => smscObject.smscId);

  const initialValues = {
    user: esme?.object.user,
    moRoutes: esme?.object.moRoutes,
    mtRoutes: esme?.object.mtRoutes,
  };

  return (
    <EsmeForm
      title='View esme'
      esmeId={esmeId}
      smscIdList={smscIdList}
      initialValues={initialValues}
      onCancel={hideEsmeForm}
      readOnly
    />
  );
};

export default EsmeViewFormContainer;
